/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
import styled from 'styled-components';
import Colors from 'constants/Colors';
import { Breakpoints } from "constants/Breakpoints";
import { mediaHelper } from "utils/src";

export const Content = styled.div`
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.PRIMARY1};
  margin: 0;
  border-radius: 10px;
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-top: 40px;
    margin-bottom: 10%;
    border-radius: 15px;
  }
  
  ${mediaHelper.md`
    border-radius: 20px;
  `}
`;

export const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 28px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: 0px;
  margin-bottom: 3rem;
`;

export const Circle = styled.div` 
  width: 20px; 
  height: 20px;
  border-radius: 100%;
  background: ${Colors.PRIMARY1};
  color: ${Colors.WHITE};
  -moz-transform: scaleY(1);
  -webkit-transform: scaleY(1);
  text-align: center;
  justify-content: center;
  display: inline-flex;
  margin-right: 10px;
  
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;